import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import DELETE_COMPLETION_CODE from '../mutations/DELETE_COMPLETION_CODE';
  
const useDeleteCompletionCode = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_COMPLETION_CODE );

    const handleCompletionCodeDelete = async ( completionCodeID, instructorLedTrainingId, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            const result = await deleteMutation( { variables: { 
                completionCodeID,
                iltID: instructorLedTrainingId
            } } );     
            
            setIsDeleting( false ); 
            
            if ( onFinishCallback ) {
                onFinishCallback( result?.data?.deleteCompletionCode?.success );
            }
            return result?.data?.deleteCompletionCode?.success;
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting code!' );
            setIsDeleting( false );
            return false;
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteCompletionCode: handleCompletionCodeDelete
        };
    }, [ isDeleting ] );
};

export default useDeleteCompletionCode;
